/* eslint-disable no-unused-vars */
import React from 'react';

import { MsalProvider } from '@azure/msal-react';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import { IconButton } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { Provider as StoreProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { COLOR } from './helpers/colors';
import i18n from './helpers/i18nMain';
import { store, persistor } from './helpers/store';
import theme from './helpers/theme';
import { Main } from './Main';

function App({ pca }) {
  const { t } = useTranslation();
  if (window.opener && window !== window.opener) {
    return null;
  }
  return (
    <StoreProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <MsalProvider instance={pca}>
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              action={key => {
                const { closeSnackbar } = useSnackbar();

                return (
                  <IconButton
                    onClick={() => {
                      closeSnackbar(key);
                    }}
                  >
                    <CloseOutlined sx={{ color: COLOR.whiteTextColor, fontSize: 14 }} />
                  </IconButton>
                );
              }}
            >
              <Main screenProps={{ t, i18n }} />
            </SnackbarProvider>
          </MsalProvider>
        </ThemeProvider>
      </PersistGate>
    </StoreProvider>
  );
}

export default App;
